import deviceServiceCharge from "./deviceServiceCharge"

export default {deviceServiceCharge}